import React, { Component } from "react";
import { Col, Card, Form, Row } from "antd";
import _ from "lodash";

class Discount extends Component {
  discountTradeIn(request, calculation) {
    const discount = _.find(request, {
      status_label: "Discount",
      status: "Approved",
    });
    const discountKacab = this.props.getValue(
      calculation,
      "name",
      "Discount Kacab"
    );
    const proyeksiGP = this.props.getValue(
      calculation,
      "name",
      "Proyeksi GP After Disc"
    );
    const productBonuses = discount ? discount.productBonuses : null;
    return (
      <Col xs={24} md={12}>
        <Card title="Diskon">
          <Form.Item label="Diskon Kacab">
            <span className="ant-form-text form-text-mod">
              {discountKacab ? this.props.formatRupiah(discountKacab) : "N/A"}
            </span>
          </Form.Item>
          <Form.Item label="Pengajuan Discount BOD">
            <span className="ant-form-text form-text-mod">
              {discount
                ? this.props.formatRupiah(
                    discount.requestPriceEdited
                      ? discount.requestPriceEdited
                      : discount.requestPrice
                  )
                : "N/A"}
            </span>
          </Form.Item>
          {productBonuses
            ? productBonuses.length > 0
              ? productBonuses.map((v, i) => (
                  <Form.Item label={v.productName} key={i}>
                    <span className="ant-form-text form-text-mod">
                      {this.props.formatRupiah(v.price)}
                    </span>
                  </Form.Item>
                ))
              : null
            : null}
          <Form.Item label="GP AUTO 2000 After Disc">
            <span className="ant-form-text form-text-mod">
              {proyeksiGP || proyeksiGP == 0
                ? this.props.formatRupiah(proyeksiGP)
                : "N/A"}
            </span>
          </Form.Item>
        </Card>
      </Col>
    );
  }

  discountNewCar(request, carPrice) {
    let totalDiscount = 0;
    let productBonuses;
    const discount = _.find(request, {
      status_label: "Discount",
      status: "Approved",
    });
    if (discount) {
      totalDiscount += discount.requestPriceEdited
        ? discount.requestPriceEdited
        : discount.requestPrice;
      productBonuses = discount.productBonuses;
      if (productBonuses && productBonuses.length > 0) {
        productBonuses.map(v => (totalDiscount += v.price));
      }
    }
    return (
      <Col xs={24} md={12}>
        <Card title="Diskon">
          <Row>
            <Col xs={24} md={12}>
              <Form.Item label="Harga Mobil">
                <span className="ant-form-text form-text-mod">
                  {this.props.formatRupiah(carPrice)}
                </span>
              </Form.Item>
              <Form.Item label="Request Discount">
                <span className="ant-form-text form-text-mod">
                  {discount
                    ? this.props.formatRupiah(discount.requestPrice)
                    : "N/A"}
                </span>
              </Form.Item>
              {discount && (
                <div>
                  <Form.Item label="Keputusan Direksi">
                    <span className="ant-form-text form-text-mod">
                      {this.props.formatRupiah(
                        discount.requestPriceEdited
                          ? discount.requestPriceEdited
                          : discount.requestPrice
                      )}
                    </span>
                  </Form.Item>
                </div>
              )}
            </Col>
            {discount && (
              <Col xs={24} md={12}>
                {productBonuses
                  ? productBonuses.length > 0
                    ? productBonuses.map((v, i) => (
                        <Form.Item label={v.productName} key={i}>
                          <span className="ant-form-text form-text-mod">
                            {this.props.formatRupiah(v.price)}
                          </span>
                        </Form.Item>
                      ))
                    : null
                  : null}
                <Form.Item label="Total Discount">
                  <span className="ant-form-text form-text-mod">
                    {this.props.formatRupiah(totalDiscount)}
                  </span>
                </Form.Item>
              </Col>
            )}
          </Row>
        </Card>
      </Col>
    );
  }
  render() {
    const { calculation, request, approvalType, carPrice } = this.props;
    if (approvalType === "Trade In")
      return this.discountTradeIn(request, calculation);
    else if (approvalType === "New Car")
      return this.discountNewCar(request, carPrice);
    else return null;
  }
}

export default Discount;



// WEBPACK FOOTER //
// src/components/Dashboard/Approval/Component/Section/Discount.js